export default "__VITE_ASSET__BOBgzxa$__"